'use client';

import { motion, AnimatePresence } from 'motion/react';
import useFeedbackModalStore from './store';
import { IconCloseModal } from 'app/components/sprites';
import FeedbackForm from './FeedbackForm';
import { IFile, IImage } from 'app/interfaces/common';
import ImageBg from 'app/components/common/ImageBg';

export default function FeedbackModal({
  image,
  placeholder,
  privacy_policy_file
}: {
  image?: IImage | null;
  placeholder?: string | null;
  privacy_policy_file?: IFile | null;
}) {
  const { isOpen, close } = useFeedbackModalStore();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed top-0 left-0 w-full h-full bg-graphite-dark z-50"
        >
          <div className="w-full h-full flex justify-center lg:items-center wrapper-main py-25 relative overflow-auto no-scrollbar">
            <div className="w-full lg:max-w-[680px] flex flex-col gap-2">
              <div className="pb-[50%] landscape:pb-[32%] relative hidden md:block">
                <ImageBg
                  src={image?.url || '/images-fallback/feedback-modal.jpg'}
                  alt={image?.alt || 'Обратная связь'}
                  placeholderDataURL={image?.placeholder_data_url}
                  skeletonTheme="graphite"
                  fill
                  className="object-cover rounded"
                />
              </div>
              <div>
                <FeedbackForm
                  placeholder={placeholder}
                  privacy_policy_file={privacy_policy_file}
                />
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={close}
            className="button w-12 h-12 xl:w-15 xl:h-15 rounded bg-graphite absolute top-5 right-3 md:right-6 group"
          >
            <IconCloseModal className="w-[14px] h-4 fill-white group-hover:fill-brown transition-colors duration-300" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
